import {Api} from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";

const target = "/balance";

export class BalanceService {

    public static getAllAssets() {
        return Api.get(apiUrl(target));
    }

    public static getAllBalances() {
        return Api.get(apiUrl(target+"/all"));
    }

    public static getBalanceByOrganization (id:number|null) {
        return Api.get(apiUrl(target+"/"+id))
    }

    public static getOrganizationsBalances(range:any, userId: number) {
        const startDate = range.from.toISOString();
        const endDate   =  range.to.toISOString();
        return Api.get(apiUrl(target+"/all?userId="+userId+"&startDate="+ startDate +"&endDate="+ endDate));
    }
    
    
}
